/** Shared chrome for the Model routing cards. */

/** The print-card chrome every card on the page shares. */
export const PRINT_CARD_CLASS = "rounded-[var(--radius-card)] border px-4 py-3";
export const PRINT_CARD_STYLE = {
  borderColor: "var(--print-border)",
  background: "var(--print-bg)",
  boxShadow: "var(--shadow-print)",
} as const;

/** Mono uppercase table header, the page's `--text-label` voice. */
export const TABLE_HEADER_CLASS =
  "text-left px-3 py-1.5 text-[10px] uppercase tracking-wider font-medium";
export const TABLE_HEADER_STYLE = {
  color: "var(--text-label)",
  fontFamily: "var(--font-mono)",
} as const;

/** The error box the page and the Eval judges card share. */
export function ErrorAlert({ message }: { message: string }) {
  return (
    <div
      className="rounded-md border px-3 py-2 text-sm"
      role="alert"
      style={{
        borderColor: "var(--error)",
        background: "color-mix(in srgb, var(--error) 10%, transparent)",
        color: "var(--error)",
      }}
    >
      {message}
    </div>
  );
}
